const Colors = ({
  Primary_Navy: '#00265A',
  Sub_Grey: '#C5CED3',
  light_grey: '#D4DDE2',
  white: '#FFFFFF',
  blue: '#00A4E5',
  Secondary_Blue: '#1545AF'
})

export default Colors